import dayjs from 'dayjs';
import 'dayjs/locale/fr';
import localizedFormat from 'dayjs/plugin/localizedFormat';

dayjs.extend(localizedFormat);
let language = window.navigator.language.slice(0, 2);
if (language !== 'fr') language = 'en';
dayjs.locale(language);
